import { render } from "./DefaultSidebar.vue?vue&type=template&id=5b31e928&scoped=true&ts=true"
import script from "./DefaultSidebar.vue?vue&type=script&lang=ts"
export * from "./DefaultSidebar.vue?vue&type=script&lang=ts"

import "./DefaultSidebar.vue?vue&type=style&index=0&id=5b31e928&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b31e928"]])

export default __exports__